var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyDashbord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_459_18772",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0644531,
    width: 159.871,
    height: 159.871,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_459_18772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0568 118.878H76.1565V93.7704H41.0568V118.878ZM41.0568 86.0842H76.1565V40.9926H41.0568V86.0842ZM83.8426 118.878H118.942V73.7865H83.8426V118.878ZM83.8426 66.1004H118.942V40.9926H83.8426V66.1004ZM35.4205 136.556C32.0557 136.556 29.2075 135.39 26.8761 133.059C24.5446 130.727 23.3789 127.879 23.3789 124.514V35.3563C23.3789 31.9915 24.5446 29.1433 26.8761 26.8119C29.2075 24.4804 32.0557 23.3147 35.4205 23.3147H124.579C127.943 23.3147 130.792 24.4804 133.123 26.8119C135.455 29.1433 136.62 31.9915 136.62 35.3563V49.1913H148.405V59.1828H136.62V74.9396H148.405V84.9312H136.62V100.688H148.405V110.68H136.62V124.514C136.62 127.879 135.455 130.727 133.123 133.059C130.792 135.39 127.943 136.556 124.579 136.556H35.4205ZM35.4205 126.564H124.579C125.091 126.564 125.561 126.351 125.988 125.924C126.415 125.497 126.629 125.027 126.629 124.514V35.3563C126.629 34.8438 126.415 34.374 125.988 33.9469C125.561 33.5199 125.091 33.3064 124.579 33.3064H35.4205C34.908 33.3064 34.4382 33.5199 34.0111 33.9469C33.5841 34.374 33.3707 34.8438 33.3707 35.3563V124.514C33.3707 125.027 33.5841 125.497 34.0111 125.924C34.4382 126.351 34.908 126.564 35.4205 126.564Z",
    fill: "#E4E4E4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDashbord);
export default __webpack_public_path__ + "static/media/empty_dashbord.4b8123b4a7d02cc6a2c81ec1c9058eac.svg";
export { ForwardRef as ReactComponent };